/**
 * PaymentCallbackView
 *
 * Handles the 3DS redirect return from Moyasar.
 * Reads transactionGuid from URL, polls GetTransactionStatus,
 * and shows success/fail based on the terminal status.
 */

import { useNavigate, useSearchParams } from 'react-router-dom';
import { TransactionStatusIndicator } from '../../components';
import { useTransactionPolling } from '../../hooks';
import { PaymentPageContainer } from '../../styles';
import { PaymentPageStatus } from '../../types';

const PaymentCallbackView = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const transactionGuid = searchParams.get('transactionGuid') ?? undefined;

  // Moyasar appends status & message to callback_url after 3DS
  const moyasarStatus = searchParams.get('status');
  const moyasarMessage = searchParams.get('message');
  const isMoyasarFailed = moyasarStatus === 'failed';
  const isMoyasarPaid = moyasarStatus === 'paid';

  // Only poll if Moyasar didn't already report a terminal result
  const { status, isPolling, isTimedOut, retry } = useTransactionPolling({
    transactionGuid,
    enabled: !isMoyasarFailed && !isMoyasarPaid,
  });

  // Derive page status from polling state + Moyasar URL params
  let pageStatus: PaymentPageStatus = 'loading';

  if (isMoyasarFailed) {
    pageStatus = 'failed';
  } else if (isMoyasarPaid) {
    pageStatus = 'success';
  } else if (isTimedOut) {
    pageStatus = 'timeout';
  } else if (status === 'Captured') {
    pageStatus = 'success';
  } else if (status === 'Failed') {
    pageStatus = 'failed';
  } else if (isPolling || status === 'Initiated' || status === 'Pending') {
    pageStatus = 'processing';
  }

  return (
    <PaymentPageContainer>
      <TransactionStatusIndicator
        status={pageStatus}
        onRetry={isMoyasarFailed ? () => navigate(-1) : retry}
        onGoHome={() => navigate('/')}
        onManageSubscriptions={() => navigate('/manage-plan')}
      />
    </PaymentPageContainer>
  );
};

export default PaymentCallbackView;
